import { render } from "./SpecialView.vue?vue&type=template&id=6f638e4d&scoped=true"
import script from "./SpecialView.vue?vue&type=script&lang=js"
export * from "./SpecialView.vue?vue&type=script&lang=js"

import "./SpecialView.vue?vue&type=style&index=0&id=6f638e4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f638e4d"]])

export default __exports__